/**
 * @module host
 */

import {isAppBridgeAction, isAppMessage} from '../actions/validator';
import {addAndRemoveFromCollection} from '../util/collection';
import {Handler, MessageTransport} from './';
/**
 * Create a MessageTransport from an IFrame.
 */
export function fromFrame(frame: HTMLIFrameElement, localOrigin: string): MessageTransport {
  const handlers: Handler[] = [];
  const parent = frame.ownerDocument.defaultView;

  parent.addEventListener('message', event => {
    if (!isAppMessage(event)) {
      return;
    }

    for (const handler of handlers) {
      handler(event);
    }
  });

  return {
    localOrigin,

    hostFrame: parent,

    dispatch(message) {
      const contentWindow = frame.contentWindow;

      if (contentWindow) {
        contentWindow.postMessage(message, '*');
      }
    },

    subscribe(handler) {
      return addAndRemoveFromCollection(handlers, handler);
    },
  };
}

/**
 * Create a MessageTransport from a parent window.
 */
export function fromWindow(contentWindow: Window, localOrigin: string): MessageTransport {
  const handlers: Handler[] = [];

  if (contentWindow !== window) {
    window.addEventListener('message', event => {
      if (
        event.source !== contentWindow ||
        !(isAppBridgeAction(event.data.payload) || isAppMessage(event))
      ) {
        return;
      }

      for (const handler of handlers) {
        handler(event);
      }
    });
  }

  return {
    localOrigin,

    hostFrame: contentWindow,

    dispatch(message) {
      contentWindow.postMessage(message, '*');
    },

    subscribe(handler) {
      return addAndRemoveFromCollection(handlers, handler);
    },
  };
}



// WEBPACK FOOTER //
// ./src/host/MessageTransport.ts